import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatDateDb, formatDateHourDb } from "../utils/tools";
import {
  customDateFormatType,
  formatDateForInput,
  formatNumber,
  formatPriceUS,
} from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.lockingManagement;
const queryKey = "totalCommission";

async function fetchStepCommison(
  currentPage,
  search,
  projectId,
  status,
  apartmentId,
  month,
  year,
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (projectId?.length) options.projectId = projectId;
    if (status?.length) options.status = status;
    if (apartmentId?.length) options.apartmentId = apartmentId;
    if (month) options.month = month;
    if (year) options.year = year;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/TotalCommission?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries,
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?._id || "",
        lockingId: item?.lockingId || "",
        codeApartment: item?.apartmentObject?.code || "-",
        nameProject:
          item?.projectObject?.name || item?.locking?.project?.name || "-",
        // period: item?.period || "",
        status: item?.paymentStatus || "",
        totalRemainingRevenueAfterTax: `${formatPriceUS(
          item?.totalRemainingRevenueAfterTax || 0,
        )} VNĐ`,
        totalAllCommissionPrice: `${formatPriceUS(
          (item?.paymentPrice || 0),
        )} VNĐ`,
        totalRemainingCommission: `${formatPriceUS(
          (item?.totalRemainingRevenueAfterTax || 0) - (item?.paymentPrice || 0),
        )} VNĐ`,
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useTotalCommission(
  search,
  projectId,
  status,
  apartmentId,
  month,
  year,
) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      queryKey,
      currentPage,
      search,
      projectId,
      status,
      apartmentId,
      month,
      year,
    ],
    queryFn: () =>
      fetchStepCommison(
        currentPage,
        search,
        projectId,
        status,
        apartmentId,
        month,
        year,
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    placeholderData: keepPreviousData,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    lockingManagementData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
